import { render, staticRenderFns } from "./CreatePackageItem.vue?vue&type=template&id=3e903dd4&scoped=true&"
import script from "./CreatePackageItem.vue?vue&type=script&lang=js&"
export * from "./CreatePackageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e903dd4",
  null
  
)

export default component.exports